// noinspection JSUnusedLocalSymbols
export function EmptyDrawer(props: EmptyDrawerProps) {
    return <></>;
}

export interface EmptyDrawerProps {}

// noinspection JSUnusedGlobalSymbols
export default EmptyDrawer;
